/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceFilterModel {
    getFixupPrototypeFunction() { return ResourceFilterModel.fixupPrototype; }

    static newInstance(model: Partial<ResourceFilterModel>): ResourceFilterModel {
        let obj = Object.assign(new ResourceFilterModel(), model);
        ResourceFilterModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceFilterModel>): ResourceFilterModel {
        if (!model) return null;
        return ResourceFilterModel.newInstance(<ResourceFilterModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceFilterModel) {
        if (!obj) return;

        models.ResourceFilterModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceFilterModel): boolean {
        Object.setPrototypeOf(obj, ResourceFilterModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of resource filter
     */
    id: string;

    /**
     * Name of resource filter
     */
    name: string;

}
